var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.clickOpenModal(_vm.promo)}}},[(!_vm.right)?_c('div',{staticClass:"coupen-list"},[_c('div',{staticClass:"busines-img"},[_c('img',{staticClass:"coupon-img",attrs:{"src":_vm.promo.coupon_image}})])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }